import React, { createContext, useContext, useMemo, useState } from "react";

const SupportChatContext = createContext(null);

export const SupportChatProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeFlow, setActiveFlow] = useState(null);
  const [flowMeta, setFlowMeta] = useState({});

  const openChat = ({ flow = null, meta = {} } = {}) => {
    setIsOpen(true);
    setActiveFlow(flow);
    setFlowMeta(meta || {});
  };

  const closeChat = () => setIsOpen(false);

  const resetFlow = () => {
    setActiveFlow(null);
    setFlowMeta({});
  };

  const value = useMemo(
    () => ({
      isOpen,
      activeFlow,
      flowMeta,
      openChat,
      closeChat,
      resetFlow,
      setActiveFlow,
      setFlowMeta,
      setIsOpen,
    }),
    [isOpen, activeFlow, flowMeta],
  );

  return (
    <SupportChatContext.Provider value={value}>
      {children}
    </SupportChatContext.Provider>
  );
};

export const useSupportChat = () => {
  const context = useContext(SupportChatContext);
  if (!context) {
    throw new Error("useSupportChat must be used within SupportChatProvider");
  }
  return context;
};
